import typo from '../../../atoms/flightBriefPdf/flightBriefTypography.module.css';
import styles from './BriefSubHeader.module.css';

/**
 * Sub-header under the logo: the wide-tracked document title, a short divider
 * and the flight date.
 * @param {object} props
 * @param {React.ReactNode} props.title - Document title (e.g. "FLIGHT BRIEFING").
 * @param {React.ReactNode} [props.date] - Formatted flight date.
 * @param {string} [props.className] - Extra class names for layout overrides.
 * @returns {JSX.Element}
 */
function BriefSubHeader({ title, date = null, className = '' }) {
  return (
    <div className={`${styles['sub-header']} ${className}`}>
      <p className={`${styles.title} ${typo['h5-light']} ${typo.uppercase} ${typo['spaced-letters']}`}>{title}</p>
      <span className={styles.divider} />
      {date ? <p className={`${styles.date} ${typo['p1-light']} ${typo.primary} ${typo.uppercase} ${typo['spaced-letters']}`}>{date}</p> : null}
    </div>
  );
}

export default BriefSubHeader;
